import { Expose } from 'class-transformer'

export class BookOptionType {
  @Expose() bookId: number

  @Expose() bookTitle: string
}
